import { render, staticRenderFns } from "./ExportConfirmDialog.vue?vue&type=template&id=824a055c&lang=pug"
import script from "./ExportConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ExportConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports